import { render, staticRenderFns } from "./AwardsSubmissionRating.vue?vue&type=template&id=ef605fac&scoped=true"
import script from "./AwardsSubmissionRating.vue?vue&type=script&lang=js"
export * from "./AwardsSubmissionRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef605fac",
  null
  
)

/* custom blocks */
import block0 from "./AwardsSubmissionRating.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports